import { useMutation, useQueryClient } from '@tanstack/react-query';

import { activateContractPriceList } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractPriceListActivate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: activateContractPriceList,
        onSuccess: (_, { contractId }) =>
            queryClient.invalidateQueries({ queryKey: queries.contracts.detail(contractId).queryKey }),
    });
};
